import { Component } from '@angular/core';
import { Options } from '@angular-slider/ngx-slider';
import { features } from 'process';

@Component({
  selector: 'app-subscription-slider',
  templateUrl: './subscription-slider.component.html',
  styleUrls: ['./subscription-slider.component.scss']
})
export class SubscriptionSliderComponent {

  isDemoForm:boolean=false;


  obj = {
    heading: "Bring FourSight to your Teams Today!",
    subHeading: "Don't leave your teams to struggle with big challenges when the FourSight assessment, platform, and workshops can help them deliver great results. Use the slider to estimate your total.",
  };

  value: number = 1;
  person: number = 1;
  certification: number = 1;

  options: Options = {
    floor: 0,
    ceil: 1000,
    step: 1,
    showTicks: true,
    showTicksValues: true,
    tickStep: 100,
    tickValueStep: 100
  };

  plans = [
    {
      title: 'Team',
      assessment: 70,
      platformUser: 70,
      features:[
        {
          label:"Assessment",
          sub:[]
        },
        {
          label:"Team Insights & Tools",
          sub:[
            "1:1 Advise",
            "Problem Solving Tools",
            "Group Profile",
            "Collaborative Teams Insights"
          ]
        },
        {
          label:"Includes a video-assisted workshop**",
          sub:[]
        },
      ],
      submit: 'Buy now',
      bundle: 120,
      person: 1,
      isPricing: true,
      isActive:true,
      discount: '',
      route:'fso-teams'
    },
    {
      title: 'Business',
      assessment: 100,
      platformUser: 100,
      certification: 1,
      features:[
        {
          label:"Assessments",
          sub:[]
        },
        {
          label:"Team Insights & Tools* users",
          sub:[
            "1:1 Advise",
            "Problem Solving Tools",
            "Group Profile",
            "Collaborative Teams Insights"
          ]
        },
        {
          label:"Certification",
          sub:[]
        },
      ],
      submit: 'Buy now',
      bundle: 1200,
      person: 100,
      isPricing: true,
      discount: 3990,
      isActive:true,
      route:'fso-business'
    },
    {
      title: 'Enterprise',
      features:[
        {
          label:"License assessment and platform",
          sub:[]
        },
        {
          label:"In-house certification",
          sub:[]
        },
        {
          label:"SSO",
          sub:[]
        },
        {
          label:"Analytics & Tracking",
          sub:[]
        },
        {
          label:"Concierge support",
          sub:[]
        },
      ],
      submit: 'Contact Us',
      isPricing: false,
      isActive:true,
      discount: '',
    }
  ];

  ngAfterViewInit() {
    let zeroThElement:any = document.querySelectorAll('.ngx-slider-inner-tooltip')
    zeroThElement[1].innerText = 1;
    this.onSliderMove(0)
    
  }

  onSliderMove(value: number) {
    this.person = value;
    this.certification = value > 100 ? Math.floor(value / 100) : 1;
    // slider not go to zero
    if(value == 0) {
     value = 1 
     this.person = 1
    }
    let allNumbers = document.querySelectorAll('.ngx-slider-inner-tooltip')
    allNumbers.forEach((num:any)=> {
      if(num.innerText == value && num.innerText != '' ) {
        num.classList.add('active');
      }else {
        num.classList.remove('active');
      }
    })
  }

  getDataFn(plan: any) {
    if(this.person <= 100){
      if(plan.title== 'Team'){
        plan.bundle = 120 * this.person;
        plan.person = this.person
        // plan.platformUser = this.person; 
      }
    }

    if(this.person > 100){
      if(plan.title == 'Business'){
        plan.bundle = 120 * this.person
        plan.person = this.person
        plan.platformUser = this.person;
        plan.assessment = this.person
        plan.certification=this.certification
        plan.discount=3990*this.certification
      }
    }
  }

  showPopup(){
    this.isDemoForm = true; 
  }

  closePopup(){
    this.isDemoForm = false;  
  }



}
